'use strict';
// This file is auto generated by changes to /Users/jnergararian/dev/UIComponents/icons/build/createIconConstants.js
// Last updated: Mon Nov 27 2017 11:50:50 GMT-0500 (EST)

"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ALIGN_CENTER': 'alignCenter',
  'ALIGN_JUSTIFY': 'alignJustify',
  'ALIGN_LEFT': 'alignLeft',
  'ALIGN_RIGHT': 'alignRight',
  'ANGLE_DOUBLE_LEFT': 'previous',
  'ANGLE_DOUBLE_RIGHT': 'next',
  'ANGLE_LEFT': 'left',
  'BUILDING_O': 'companies',
  CALENDAR: 'date',
  CALL: 'calling',
  CHAIN: 'link',
  CHECK: 'success',
  CHECK2: 'success',
  CLOCK: 'time',
  CLOCK2: 'time',
  CLOSE: 'remove',
  'CLOUD_UPLOAD': 'upload',
  'CLEAR_FORMATTING': 'eraseStyles',
  'COMMENT_O': 'comments',
  'COMMENTS_O': 'comments',
  CONTACT: 'contacts',
  CONTACTS2: 'contacts',
  COPY: 'duplicate',
  CROSS2: 'remove',
  'CTA_CLICK': 'ctas',
  DEAL: 'deals',
  DEDENT: 'outdent',
  DOCUMENT: 'documents',
  'DOWN_ANGLE': 'down',
  'DOWN_ARR': 'down',
  'EMAIL_OPEN': 'emailOpen',
  EMBED2: 'code',
  ERASER: 'eraseStyles',
  'EXTERNAL_LINK': 'externalLink',
  EYE: 'view',
  'EYE_SLASH': 'hide',
  'FILE_TEXT': 'file',
  'FOLDER_OPEN': 'folderOpen',
  FONT: 'textColor',
  FORM: 'forms',
  GEAR: 'settings',
  GLOBE: 'language',
  HAMBURGER: 'listView',
  HANDSHAKE: 'deals',
  'HELP_WITH_CIRCLE': 'info',
  LAYER: 'hubdb',
  'LEFT_ANGLE': 'left',
  'LEFT_ARR': 'left',
  'LEFT_ARROW': 'previous',
  'LIST_OL': 'numberList',
  'LIST_UL': 'bulletList',
  LOCK: 'locked',
  MAIL: 'email',
  'MAIL_DARK': 'email',
  MICROPHONE: 'record',
  NEWSPAPER: 'blog',
  PEN: 'signature',
  PENCIL: 'edit',
  PHONE: 'calling',
  PHOTO: 'insertImage',
  PLUS: 'add',
  'PRICE_TAG': 'tag',
  'QUOTES_LEFT': 'insertQuote',
  'RIGHT_ARR': 'right',
  'RIGHT_ARROW': 'next',
  STAR: 'favorite',
  'STAR_O': 'favorite',
  TRASH: 'delete',
  TRASH2: 'delete',
  'UP_ARR': 'up',
  'UP_ANGLE': 'up',
  'UPLOAD_DARK': 'upload',
  'UPLOAD_LIGHT': 'upload',
  USER: 'contacts',
  'VOLUME_DOWN': 'volumeDown',
  'VOLUME_UP': 'volumeUp',
  'VOLUME_OFF': 'volumeMute',
  'WARNING_TRIANGLE': 'warning',
  X: 'remove',
  'ZOOM_IN': 'zoomIn',
  'ZOOM_OUT': 'zoomOut',

  // v1 social icon aliases
  YOUTUBE_PLAY: 'socialYoutubeplay',
  YOUTUBE: 'socialYoutube',
  XING: 'socialXing',
  TWITTER: 'socialTwitter',
  PINTEREST: 'socialPinterest',
  LINKEDIN: 'socialLinkedin',
  GOOGLE_PLUS: 'socialGoogleplus',
  GOOGLE_PLUS2: 'socialGoogleplus',
  GOOGLE: 'socialGoogle',
  GOOGLE_DRIVE: 'socialGoogleDrive',
  GOOGLE_DRIVE2: 'socialGoogleDrive',
  FACEBOOK: 'socialFacebook',
  BLOCK_YOUTUBE_PLAY: 'socialBlockYoutubeplay',
  BLOCK_YOUTUBE: 'socialBlockYoutube',
  BLOCK_XING: 'socialBlockXing',
  BLOCK_TWITTER: 'socialBlockTwitter',
  BLOCK_RSS: 'socialBlockRss',
  BLOCK_PINTEREST: 'socialBlockPinterest',
  BLOCK_LINKEDIN: 'socialBlockLinkedin',
  BLOCK_GOOGLE_PLUS: 'socialBlockGoogleplus',
  BLOCK_FACEBOOK: 'socialBlockFacebook',
  RSS: 'socialRss',

  INTEGRATIONSSALESFORCE: "integrationsSalesForce",
  INTEGRATIONSSURVEYMONKEY: "integrationsSurveyMonkey",
  OFFICE365: "office365",
  SOCIALBLOCKINSTAGRAM: "socialBlockInstagram",
  SOCIALRETWEET: "socialRetweet",
  SOCIALHEART: "socialHeart",
  SOCIALINSTAGRAM: "socialInstagram",
  SOCIALGOOGLE: "socialGoogle",
  SOCIALGOOGLEDRIVE: "socialGoogleDrive",
  SOCIALYOUTUBEPLAY: "socialYoutubeplay",
  SOCIALYOUTUBE: "socialYoutube",
  SOCIALXING: "socialXing",
  SOCIALTWITTER: "socialTwitter",
  SOCIALPINTEREST: "socialPinterest",
  SOCIALLINKEDIN: "socialLinkedin",
  SOCIALGOOGLEPLUS: "socialGoogleplus",
  SOCIALFACEBOOK: "socialFacebook",
  SOCIALBLOCKYOUTUBEPLAY: "socialBlockYoutubeplay",
  SOCIALBLOCKYOUTUBE: "socialBlockYoutube",
  SOCIALBLOCKXING: "socialBlockXing",
  SOCIALBLOCKTWITTER: "socialBlockTwitter",
  SOCIALBLOCKRSS: "socialBlockRss",
  SOCIALBLOCKPINTEREST: "socialBlockPinterest",
  SOCIALBLOCKLINKEDIN: "socialBlockLinkedin",
  SOCIALBLOCKGOOGLEPLUS: "socialBlockGoogleplus",
  SOCIALBLOCKFACEBOOK: "socialBlockFacebook",
  SOCIALRSS: "socialRss",
  DESKTOP: "desktop",
  GENERATECHART: "generateChart",
  GRID: "grid",
  LISTVIEW: "listView",
  MOBILE: "mobile",
  TABLET: "tablet",
  SORTALPASC: "sortAlpAsc",
  SORTALPDESC: "sortAlpDesc",
  SORTAMTASC: "sortAmtAsc",
  SORTAMTDESC: "sortAmtDesc",
  SORTNUMASC: "sortNumAsc",
  SORTNUMDESC: "sortNumDesc",
  THUMBSDOWN: "thumbsDown",
  THUMBSUP: "thumbsUp",
  HANDOFFAGENT: "handoffAgent",
  EXCLAMATION: "exclamation",
  STYLES: "styles",
  TEXTSNIPPET: "textSnippet",
  BUBBLE: "bubble",
  UNLOCKED: "unlocked",
  LOCKED: "locked",
  GLOBALGROUP: "globalGroup",
  LOCATION: "location",
  CALLINGMADE: "callingMade",
  CALLINGMISSED: "callingMissed",
  LOGO: "logo",
  NOTIFICATION: "notification",
  SPROCKET: "sprocket",
  CALLINGHANGUP: "callingHangup",
  MENU: "menu",
  THEME: "theme",
  EMOJI: "emoji",
  ROTATELEADS: "rotateLeads",
  CUSTOMHUBL: "customHubl",
  GROUPMODULE: "groupModule",
  IMAGEGALLERY: "imageGallery",
  PARTIAL: "partial",
  RICHTEXT: "richText",
  SPLITMODULE: "splitModule",
  TIME: "time",
  BLANK: "blank",
  CALLING: "calling",
  COMMENTS: "comments",
  DRAGANDDROPLAYOUT: "dragAndDropLayout",
  HUBDB: "hubDB",
  FILE: "file",
  FONTFILE: "fontFile",
  JSFILE: "jsFile",
  HTMLFILE: "htmlFile",
  CSSFILE: "cssFile",
  PDFFILE: "pdfFile",
  THEMEFILE: "themeFile",
  VIDEOFILE: "videoFile",
  CONDITIONAL: "conditional",
  CUSTOMMODULES: "customModules",
  HEADER: "header",
  TEXT: "text",
  DELAY: "delay",
  DATE: "date",
  DESCRIPTION: "description",
  DRAGHANDLE: "dragHandle",
  ENROLL: "enroll",
  FOLDER: "folder",
  FOLDEROPEN: "folderOpen",
  FLEXCOLUMN: "flexColumn",
  FOOTER: "footer",
  GOAL: "goal",
  INFO: "info",
  LANGUAGE: "language",
  SETTINGS: "settings",
  SMS: "sms",
  SPACER: "spacer",
  SUCCESS: "success",
  TAG: "tag",
  REPORTSPAM: "reportSpam",
  TEST: "test",
  WARNING: "warning",
  LINK: "link",
  IMAGEALIGNMENTLEFT: "imageAlignmentLeft",
  IMAGEALIGNMENTMIDDLE: "imageAlignmentMiddle",
  IMAGEALIGNMENTRIGHT: "imageAlignmentRight",
  IMAGEALIGNMENTTOP: "imageAlignmentTop",
  SECTIONHEADER: "sectionHeader",
  SIGNATURE: "signature",
  PARAGRAPH: "paragraph",
  ALIGNJUSTIFY: "alignJustify",
  CODE: "code",
  ERASESTYLES: "eraseStyles",
  INSERTQUOTE: "insertQuote",
  BACKGROUNDCOLOR: "backgroundColor",
  INDENT: "indent",
  OUTDENT: "outdent",
  ATTACH: "attach",
  INSERTIMAGE: "insertImage",
  INSERTVIDEO: "insertVideo",
  REDO: "redo",
  UNDO: "undo",
  SPELLCHECK: "spellCheck",
  UNLINK: "unlink",
  NUMBERLIST: "numberList",
  BULLETLIST: "bulletList",
  ALIGNCENTER: "alignCenter",
  ALIGNLEFT: "alignLeft",
  ALIGNRIGHT: "alignRight",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  TEXTCOLOR: "textColor",
  UNDERLINE: "underline",
  ITALIC: "italic",
  BOLD: "bold",
  INBOX: "inbox",
  ELLIPSES: "ellipses",
  EXPAND: "expand",
  SHARE: "share",
  MESSAGES: "messages",
  TASKS: "tasks",
  CTAS: "ctas",
  SOCIAL: "social",
  INTEGRATIONS: "integrations",
  COMPANIES: "companies",
  DATABASES: "databases",
  DEALS: "deals",
  DOCUMENTS: "documents",
  SEQUENCES: "sequences",
  CONTACTPROPERTIES: "contactProperties",
  CONTACTS: "contacts",
  LISTS: "lists",
  MEETINGS: "meetings",
  FORMS: "forms",
  SALESTEMPLATES: "salesTemplates",
  WEBSITE: "website",
  WORKFLOWS: "workflows",
  BLOG: "blog",
  EMAIL: "email",
  EMAILOPEN: "emailOpen",
  NOTEDITABLE: "notEditable",
  REPLACE: "replace",
  ROTATE: "rotate",
  SWITCHER: "switcher",
  REPLY: "reply",
  REPLYALL: "replyAll",
  POPOUT: "popOut",
  MERGE: "merge",
  FAVORITEHOLLOW: "favoriteHollow",
  PIN: "pin",
  PLAYERFASTFORWARD: "playerFastForward",
  PLAYERPAUSE: "playerPause",
  PLAYERPLAY: "playerPlay",
  PLAYERREWIND: "playerRewind",
  STOPRECORD: "stopRecord",
  FIRST: "first",
  LAST: "last",
  DOWNCARAT: "downCarat",
  UPCARAT: "upCarat",
  ADD: "add",
  MINUS: "minus",
  ARCHIVE: "archive",
  DELETE: "delete",
  DOWNLOAD: "download",
  UPLOAD: "upload",
  DUPLICATE: "duplicate",
  EDIT: "edit",
  EDITCOLUMNS: "editColumns",
  EXTERNALLINK: "externalLink",
  FAVORITE: "favorite",
  FILTER: "filter",
  VIEW: "view",
  HIDE: "hide",
  LEFT: "left",
  UP: "up",
  DOWN: "down",
  RIGHT: "right",
  NEXT: "next",
  PREVIOUS: "previous",
  RECORD: "record",
  REFRESH: "refresh",
  REMOVE: "remove",
  VOLUME: "volume",
  VOLUMEDOWN: "volumeDown",
  VOLUMEMUTE: "volumeMute",
  VOLUMEUP: "volumeUp",
  SEARCH: "search",
  ZOOMIN: "zoomIn",
  ZOOMOUT: "zoomOut"
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/icons/static-2.89/javascripts/icons.js
// module id = 38
// module chunks = 0 1